import { FunctionalComponent } from 'preact'

/* eslint-disable import/no-internal-modules */
import Icon from '@insided/deprecated-preact-components/assets'
import Dropdown from '@insided/deprecated-preact-components/dropdown'
import UserAvatar, { User } from '@insided/deprecated-preact-components/User/UserAvatar'
import globals from '@insided/deprecated-utils/globals'
/* eslint-enable import/no-internal-modules */

export interface TopNavigationProps {
  privateMessagesUnreadCount: string | number
  user: User
}

const TopNavigation: FunctionalComponent<TopNavigationProps> = ({ privateMessagesUnreadCount, user }) => {
  const communityUrl = globals('communityUrl')
  return (
    <div className='top-navigation'>
      <div className='top-navigation-content'>
        <div className='top-navigation-page_title'>{/** stub for the future */}</div>
        <div className='top-navigation-user_controls'>
          <a
            href={communityUrl}
            target='_blank'
            rel='noreferrer'
            title='Open community'
            aria-label='Open the community in a new browser tab'
          >
            <Icon icon='navigationDigitalHub' />
          </a>
          <a href='/team' title='Team overview' aria-label='Open the Team overview page'>
            <Icon icon='navigationTeam' />
          </a>
          <a
            href='/privateMessages/overview#conversations'
            className='top-navigation-private_messages_link'
            title='Private Messages'
            aria-label='Open the Private Message page'
          >
            <Icon icon='navigationMessage' />
            {Number(privateMessagesUnreadCount) > 0 && <div className='top-navigation-private_messages_unread' />}
          </a>
          <div className='top-navigation-profile'>
            <Dropdown
              popupName='top-navigation-profile__menu'
              trigger={<UserAvatar user={user} disableLink extraClass='top-navigation-profile' />}
            >
              <ul className='top-navigation-profile__menu-user'>
                <a href={user.url} className='top-navigation-profile__menu-item-user-link'>
                  <UserAvatar user={user} />
                  <div className='top-navigation-profile__menu-user-details'>
                    <div>{user.name}</div>
                    <div className='text--meta'>See your profile</div>
                  </div>
                </a>
                <hr className='top-navigation-profile__menu-item-separator' />
                <li>
                  <Icon icon='navigationLogout' />
                  <a href='/member/logout'>Log out</a>
                </li>
              </ul>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopNavigation
